export function EmptyData(props) {
    const { emptyImg } = props || {};
    return <div style={{ textAlign: 'center', padding: '16px 0' }}>
    <img style={{ height: '100px' }} src={emptyImg} alt=""/>
    <div style={{ paddingTop: '10px' }}>
      暂无数据
    </div>
  </div>;
}
